import { useMemo } from "react";
import {
  TextField,
  DatagridConfigurable,
  useTheme,
  NumberField,
} from "react-admin";
import getFirstAndLastDateOfCurrentMonth from "../../utils/firstLastDate";
import DownloadAction from "../../components/tableListActions/DownloadActionNew";
import MyDatagridBody from "../../components/common/MyDatagridBody";
import salesmanPenaltyDetailFilterList from "../../components/salesmanPenaltyDetails/filter/salesmanPenaltyDetailFilterList";
import SalesmanPenaltyDetailExpandList from "../../components/salesmanPenaltyDetails/expand/SalesmanPenaltyDetailExpandList";
import SalesmanPenaltyDetailFooterList from "../../components/salesmanPenaltyDetails/footer/SalesmanPenaltyDetailFooterList";
import ManualReportList from "../../components/reports/ManualReportList";

const [firstDate, lastDate] = getFirstAndLastDateOfCurrentMonth();

const SalesmanPenaltyDetailList = () => {
  const [theme] = useTheme("light");

  const list = useMemo(
    () => (
      <ManualReportList
        title="mine.label.salesman_penalty_detail"
        empty={false}
        actions={<DownloadAction />}
        filters={salesmanPenaltyDetailFilterList()}
        filterDefaultValues={{
          start_date: firstDate,
          end_date: lastDate,
        }}
        requiredFilters={["start_date", "end_date"]}
        sx={{
          "& .RaDatagrid-root, & .RaDatagrid-tableWrapper": {
            overflowX: "auto",
          },
          "& .RaDatagrid-table": {
            minWidth: "1900px",
            tableLayout: "fixed",
          },
          "& .RaDatagrid-headerCell, & .RaDatagrid-rowCell": {
            whiteSpace: "nowrap",
          },
        }}
      >
        <DatagridConfigurable
          body={<MyDatagridBody footer={<SalesmanPenaltyDetailFooterList />} />}
          bulkActionButtons={false}
          expandSingle={true}
          isRowExpandable={(row) =>
            Array.isArray(row?.details) && row.details.length > 0
          }
          expand={<SalesmanPenaltyDetailExpandList />}
          sx={{
            "& .RaDatagrid-expandedPanel > td": {
              p: 0,
              bgcolor: theme !== "dark" ? "#E7EBF0" : "grey.800",
            },
          }}
        >
          <TextField source="name" label="mine.label.name" />
          <NumberField source="target_qty" label="Qty Target" />
          <NumberField source="gross_qty" label="Qty Kotor" />
          <NumberField source="return_qty" label="Retur Depo" />
          <NumberField source="net_qty" label="Qty Net Depo" />
          <NumberField source="gross_value" label="Nilai Kotor Depo" />
          <NumberField source="return_value" label="Nilai Retur" />
          <NumberField source="correction_value" label="Koreksi Piutang" />
          <NumberField source="net_value" label="Nilai Net Depo" />
          <NumberField source="total_payment" label="Total Bayar" />
          <NumberField source="total_ret_pot" label="Ret/Pot" />
          <NumberField source="total_penalty_lte_90" label="<=90" />
          <NumberField
            source="total_penalty_gt_90_lte_120"
            label=">90 <=120"
          />
          <NumberField source="total_penalty_gt_120" label=">120" />
        </DatagridConfigurable>
      </ManualReportList>
    ),
    [theme]
  );

  return list;
};

export default SalesmanPenaltyDetailList;
